<template>
  <div class="w-full p-4 bg-white rounded-lg shadow-md">
    <div class="flex items-center justify-between mb-2">
      <h3 class="text-lg font-medium text-gray-800">
        Roblox Stats (Last 60 Days)
      </h3>

      <button
        type="button"
        :disabled="loading"
        @click="fetchStats"
        class="text-sm text-blue-600 hover:text-blue-800 disabled:opacity-50"
      >
        Refresh
      </button>
    </div>

    <div v-if="loading" class="py-4 text-center text-gray-500">
      Fetching Roblox overview statistics...
    </div>

    <div v-else-if="error" class="py-4 text-center">
      <p class="text-red-600">{{ error }}</p>
      <button
        type="button"
        @click="fetchStats"
        class="mt-2 text-sm text-blue-600 hover:underline"
      >
        Try Again
      </button>
    </div>

    <div v-else class="grid grid-cols-1 md:grid-cols-2">
      <ul
        v-for="region in regions"
        :key="region.key"
      >
        <li
          v-for="stat in stats[region.key]"
          :key="stat.name"
          class="flex text-gray-700 mb-2"
        >
          <span class="mr-2">{{ stat.name }}:</span>
          <span class="font-medium">{{ stat.value }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "RobloxOverviewStats",

  data() {
    return {
      loading: false,
      error: null,
      stats: {
        global: [],
        us: [],
      },
      regions: [
        { key: "global", label: "Global" },
        { key: "us", label: "United States" },
      ],
    };
  },

  methods: {
    async fetchStats() {
      this.loading = true;
      this.error = null;

      try {
        const { data } = await this.$http.get("/roblox/overview-stats");

        if (!Array.isArray(data.global) || !Array.isArray(data.us)) {
          throw new Error("Invalid Roblox overview response");
        }

        this.stats = data;
      } catch (error) {
        console.error("Failed to fetch Roblox overview:", error);

        this.error =
          error.response?.data?.message ||
          "Failed to fetch Roblox overview statistics.";
      } finally {
        this.loading = false;
      }
    },
  },

  mounted() {
    this.fetchStats();
  },
};
</script>